import React from 'react'
import { ConfigProvider, Row, Col, Input, Button, Modal, message, Tag } from 'antd'
import zhCN from 'antd/es/locale/zh_CN';  // 引入中文包
import { PlusOutlined } from '@ant-design/icons'
import './index.css'
import Axios from 'axios';



var defaultTabs = [], extraTabs = []
export default class BaseHeader extends React.Component {

    state = {
        visible: false,
        typeValue: '',
        tabs: [],
        extraTabs: [],
        isShowMore: false
    }

    showModal = () => {
        this.setState({
            visible: true,
        });
    };

    handleOk = e => {
        //const formData = new FormData();
        //formData.append("type", this.state.typeValue)
        const data = {
            type: this.state.typeValue
        }
        Axios.post("http://localhost:8081/wareHouse/intsert",data, {
            headers:{
                "Content-Type": "application/json; charset=utf-8"
            }
        })
        .then(res => {
            console.log(res.data)
        })
        message.info(`新建了一个${this.state.typeValue}分类`)
        this.setState({
            visible: false,
            typeValue: ''
        })
    }

    handleCancel = e => {
        console.log(e);
        this.setState({
            visible: false,
            typeValue: ''
        })

    }

    getTypeValue = e => {
        //console.log(e.target.value)
        this.setState({
            typeValue: e.target.value
        })
    }


    componentDidMount() {
        // Axios.get('http://localhost:8081/wareHouse/getWareHouses/0/10')
        Axios.get('../data/baseTabs.json')
            .then(res => {
                console.log(res.data)
                this.setState({
                    tabs: res.data
                })
            })
    }


    showMoreType = () => {
        let j = 0
        for (let item of this.state.tabs) {
            if (j < 16) {
                defaultTabs[j] = item
                j++
            } else {
                extraTabs[j - 16] = item
                j++
            }
        }

        if (defaultTabs.length >= 16) {
            return (
                <React.Fragment>
                    {defaultTabs.map(item => <Tag key={item.id} id={item.tid}>{item.tab}</Tag>)}
                    <Tag key="more" color="red" onClick={this.show_hidden}>
                        {this.state.isShowMore ? "收起" : "更多"}
                    </Tag>
                </React.Fragment>
            )
        }
        return (
            defaultTabs.map(item => <Tag key={item.id} id={item.tid}>{item.type}</Tag>)
        )

    }
    show_hidden = () => {
        // debugger
        if (this.state.isShowMore === false) {
            this.setState({ isShowMore: true })
            this.props.parent.getChildrenMsg(this, this.state.isShowMore)
            return
        }
        this.setState({ isShowMore: false })
        this.props.parent.getChildrenMsg(this, this.state.isShowMore)
    }

    showMore = () => {
        if (this.state.isShowMore) {
            return (
                extraTabs.map(item => <Tag id={item.tid}>{item.tab}</Tag>)
            )
        }
    }


    render() {
        return (
            <ConfigProvider locale={zhCN}>
                <Row>
                    <Col offset={2}>
                        <Input.Search
                            placeholder="请输入关键字"
                            enterButton="搜索"
                            className="btn-searchType"
                        // size="large"
                        // onSearch={value => console.log(value)}
                        />
                    </Col>
                    <Col span={2} offset={1} className="btn-type">
                        <Button type="dashed" icon={<PlusOutlined />} className="btn-type" onClick={this.showModal}>分类</Button>
                        <Modal
                            title="新建分类"
                            visible={this.state.visible}
                            onOk={this.handleOk}
                            onCancel={this.handleCancel}
                        >
                            <Input value={this.state.typeValue} onChange={this.getTypeValue} placeholder="请输入分类名称" />
                        </Modal>
                    </Col>
                </Row>
                <Row className="type-row">
                    <Col offset={1}>
                        <Tag color="#2db7f5">全部分类</Tag>
                        {this.showMoreType()}
                    </Col>
                </Row>
                <Row className="type-row-more">
                    <Col offset={1} className="type-col-more">
                        {this.showMore()}
                    </Col>
                </Row>
            </ConfigProvider>
        )
    }
}